import { useState, useEffect } from 'react'
import { BrowserRouter, Routes, Route } from 'react-router'
import { useDispatch } from 'react-redux'
import { setConfigs } from 'store/configSlice'
import MobileViewApp from 'mobile/mobileview'
import Header from 'common/header'
import NavBar from 'common/navbar'
import Home from 'pages/Home/home'
import PriorityProgramme from 'pages/PriorityProgramme/priorityprogramme'
import EarnWins from 'pages/EarnWins/earnwins'
import SpendWins from 'pages/SpendWins/spendwins'
import HelpCentre from 'pages/HelpCentre/helpcentre'
import QuickLinks from 'common/quicklinks'
import Footer from 'common/footer'
import styled from 'styled-components'
import { CookiesProvider } from 'react-cookie'

const PageContainer = styled.div`
    width: 100%;
    height: 100%;
`

function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window
    return {
        width,
        height,
    }
}

function useWindowDimensions() {
    const [windowDimensions, setWindowDimensions] = useState(
        getWindowDimensions()
    )

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions())
        }

        window.addEventListener('resize', handleResize)
        return () => window.removeEventListener('resize', handleResize)
    }, [])

    return windowDimensions
}

function App(data: any) {
    const { width } = useWindowDimensions()
    const dispatch = useDispatch()

    useEffect(() => {
        const setConfigurations = () => {
            return dispatch(setConfigs(data.configs))
        }
        setConfigurations()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <BrowserRouter>
            <CookiesProvider defaultSetOptions={{ path: '/' }}>
                {width > 768 ? (
                    <PageContainer>
                        <Header />
                        <NavBar />
                        <Routes>
                            <Route index element={<Home />} />
                            <Route
                                path="hkjcpriorityprogramme"
                                element={<PriorityProgramme />}
                            />
                            <Route path="earnwins" element={<EarnWins />} />
                            <Route path="spendwins" element={<SpendWins />} />
                            <Route path="helpcentre" element={<HelpCentre />} />
                        </Routes>
                        <QuickLinks />
                        <Footer />
                    </PageContainer>
                ) : (
                    <MobileViewApp />
                )}
            </CookiesProvider>
        </BrowserRouter>
    )
}

export default App
